import React, { useState, useEffect } from "react";
import "./WordBingo.css";

const wordsPool = [
  "CAT","DOG","APPLE","BANANA","ROCKET","SUN","MOON","STAR",
  "TREE","CAR","HOUSE","BOOK","PEN","FISH","BIRD","BALL",
  "CHAIR","TABLE","WATER","FIRE","EARTH","SKY","CLOUD","RAIN",
  "FLOWER","GRASS","MILK","BREAD","CHEESE","EGG","RIVER","MOUNTAIN",

  // ✅ 40 new words (no repeats)
  "LION","TIGER","HORSE","ELEPHANT","ZEBRA","MONKEY","BEAR","FOX",
  "ORANGE","GRAPE","PEAR","PEACH","MANGO","LEMON","CHERRY","PLUM",
  "TRAIN","PLANE","SHIP","BIKE","BUS","TRUCK","BRIDGE","ROAD",
  "PARK","CITY","VILLAGE","CASTLE","SCHOOL","MARKET","TEMPLE","CHURCH",
  "CLOCK","PHONE","RADIO","CAMERA","LAMP","BOTTLE","PLATE","CUP"
];


function shuffle(array) {
  return array.sort(() => Math.random() - 0.5);
}

export default function WordBingo() {
  const [board, setBoard] = useState([]);
  const [message, setMessage] = useState("");
  const [score, setScore] = useState(0);
  const [targetWord, setTargetWord] = useState("");
  const [highlightWord, setHighlightWord] = useState("");
  const [progress, setProgress] = useState(0);
  const [level, setLevel] = useState(1);

  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");

  useEffect(() => {
    resetBoard();
  }, []);

  const speak = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    speechSynthesis.speak(utterance);
  };

  const speakWord = (word) => {
    speak(word);
  };

  const nextWord = () => {
    const randomWord = board[Math.floor(Math.random() * board.length)];
    setTargetWord(randomWord);
    setHighlightWord("");
    speakWord(randomWord);
  };

  const handleClick = (word) => {
    if (word === targetWord) {
      setMessage("🎉 Correct!");
      setScore(score + 10);
      correctSound.play();
      speak(`Correct`);
    } else {
      setMessage("❌ Wrong!");
      setScore(score - 5);
      wrongSound.play();
      setHighlightWord(targetWord);
      speak(`Wrong! The word was ${targetWord}`);
    }

    // Progress tracking
    setProgress(prev => {
      const newProgress = prev + 1;
      if (newProgress >= 10) { // every 10 words = new level
        setLevel(level + 1);
        speak(`Level up! Welcome to level ${level + 1}`);
        return 0; // reset progress bar
      }
      return newProgress;
    });

    setTimeout(() => {
      setMessage("");
      nextWord();
    }, 2000);
  };

  const resetBoard = () => {
    const shuffled = shuffle([...wordsPool]).slice(0, 25);
    setBoard(shuffled);
    setMessage("");
    setScore(0);
    setTargetWord("");
    setHighlightWord("");
    setProgress(0);
    setLevel(1);
  };

  return (
  <div className="bingo-container">
    <h1>🔤 Word Bingo 5x5</h1>
    <button className="start-btn" onClick={nextWord}>▶️ Start Word</button>
      <p className="target">🎧 Listen & Find: {targetWord}</p>

    {/* Info section */}
    <div className="info-panel">
        <br/>
      <br/>
      <p className="score">⭐ Score: {score}</p>
      <br/>
      <p className="level">🏆 Level: {level}</p>
    </div>
<div><br/><br/></div>
    {/* Progress bar */}
    <div className="progress-container">
      <div className="progress-bar" style={{ width: `${(progress/10)*100}%` }}></div>
    </div>

    <div className="board">
      {board.map((word, i) => (
        <div
          key={i}
          className={`cell ${word === highlightWord ? "highlight" : ""}`}
          onClick={() => handleClick(word)}
        >
          {word}
        </div>
      ))}
    </div>

    <p className="status">{message}</p>
    <button className="reset-btn" onClick={resetBoard}>🔄 New Board</button>
  </div>
);

}
